import { createAction, props, createReducer, on } from '@ngrx/store';
import { OldBookingInfo } from '../models/old-booking-info.model';

// Action creators using createAction
export const saveOldBookingsData = createAction(
  '[OldBookingInfo] Save Old Bookings Data',
  props<{ payload: { abcBooking: any, ccdBooking: any } }>()
);

export const saveD2DBookingsData = createAction(
  '[OldBookingInfo] Save D2D Bookings Data',
  props<{ payload: any }>()
);

export const refreshOldBookingInfoReducer = createAction(
  '[OldBookingInfo] Refresh Old Booking Info Reducer',
  props<{ payload: any }>()
);

export const resetOldBookingInfoReducer = createAction(
  '[OldBookingInfo] Reset Old Booking Info Reducer'
);

// Initial state
const initialState: OldBookingInfo = {
  abcBooking: null,
  ccdBooking: null,
  d2dReducer: null
};

// Reducer using createReducer and on
export const oldBookingInfoReducer = createReducer(
  initialState,
  on(saveOldBookingsData, (state, { payload }) => ({
    ...state,
    abcBooking: payload.abcBooking,
    ccdBooking: payload.ccdBooking,
  })),
  on(saveD2DBookingsData, (state, { payload }) => ({
    ...state,
    d2dReducer: payload,
  })),
  on(refreshOldBookingInfoReducer, (state, { payload }) => ({
    ...payload,
  })),
  on(resetOldBookingInfoReducer, () => ({
    ...initialState,
  }))
);
